(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dodomine-journey"] && !Shopify.designMode) return;
  try {
    
function initDodoTabs(){document.querySelectorAll('[data-dodo-section="journey"]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';
const tabs=[...root.querySelectorAll('[role="tab"]')],panels=[...root.querySelectorAll('[role="tabpanel"]')];
const activateTab=(tab,focus=false)=>{tabs.forEach((item,i)=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;panels[i].hidden=!selected;});if(focus)tab.focus();};
tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activateTab(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();activateTab(tabs[next],true);}});});
});}
initDodoTabs();document.addEventListener('shopify:section:load',initDodoTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dodomine-travel-pdp"] && !Shopify.designMode) return;
  try {
    

function initDodo(){
document.querySelectorAll('[data-dodo-section="product"]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';const controller=new AbortController();const signal=controller.signal;const cleanup=[];root.dodoCleanup=()=>{controller.abort();cleanup.forEach(fn=>fn());};

{const slides=[...root.querySelectorAll('.dp-headline-slide')],dots=[...root.querySelectorAll('.dp-heading-dots i')],toggle=root.querySelector('.dp-rotation-toggle'),motion=window.matchMedia('(prefers-reduced-motion: reduce)');
let active=0,paused=false,timer;
const stop=()=>{clearInterval(timer);timer=null;};
const start=()=>{stop();if(!slides.length||paused||motion.matches||document.hidden||!root.isConnected||window.Shopify?.designMode)return;timer=setInterval(()=>{if(!root.isConnected){stop();return;}slides[active].classList.remove('is-active');dots[active].classList.remove('is-active');active=(active+1)%slides.length;slides[active].classList.add('is-active');dots[active].classList.add('is-active');},2000);};
toggle?.addEventListener('click',()=>{paused=!paused;toggle.setAttribute('aria-pressed',String(paused));toggle.setAttribute('aria-label',paused?toggle.dataset.resume:toggle.dataset.pause);toggle.querySelector('span').textContent=paused?'▶':'Ⅱ';start();});
motion.addEventListener('change',start,{signal});document.addEventListener('visibilitychange',start,{signal});cleanup.push(stop);start();}
const offer=root.querySelector('.dp-offer');
const updateKit=()=>{const field=root.querySelector('[name="quantity"]');const n=parseInt(field?.value||'',10);root.querySelectorAll('[data-kit-quantity]').forEach(el=>{const value=Number.isFinite(n)&&n>0?String(n):'1';if(el.textContent!==value)el.textContent=value;});};
offer.addEventListener('change',updateKit,{signal});offer.addEventListener('click',()=>setTimeout(updateKit,100),{signal});const observer=new MutationObserver(updateKit);observer.observe(offer,{subtree:true,attributes:true,attributeFilter:['class','value'],childList:true});cleanup.push(()=>observer.disconnect());updateKit();
const main=root.querySelector('.dp-main-img'),galleryVideo=root.querySelector('.dp-gallery-video'),caption=root.querySelector('.dp-gallery-caption'),photoCaption=caption.textContent;
cleanup.push(()=>galleryVideo?.pause());
root.querySelectorAll('.dp-thumb').forEach(button=>button.addEventListener('click',()=>{
const isVideo=button.dataset.video==='true';main.hidden=isVideo;
if(galleryVideo){galleryVideo.hidden=!isVideo;galleryVideo.pause();if(isVideo){galleryVideo.muted=true;galleryVideo.play().catch(()=>{});}}
if(!isVideo){main.src=button.dataset.src;main.removeAttribute('srcset');main.alt=button.dataset.alt;}
caption.textContent=isVideo?caption.dataset.videoCaption:photoCaption;
root.querySelectorAll('.dp-thumb').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
},{signal}));
// Swipe through gallery items while preserving vertical page scrolling.
const galleryMain=root.querySelector('.dp-gallery-main'),thumbs=[...root.querySelectorAll('.dp-thumb')],thumbRail=root.querySelector('.dp-thumbs');
let swipeStart=null;
galleryMain.addEventListener('touchstart',event=>{
  if(event.touches.length!==1){swipeStart=null;return;}
  const touch=event.touches[0],rect=galleryMain.getBoundingClientRect();
  if(event.target.closest('video')&&touch.clientY>rect.bottom-64){swipeStart=null;return;}
  swipeStart={x:touch.clientX,y:touch.clientY};
},{passive:true,signal});
galleryMain.addEventListener('touchend',event=>{
  if(!swipeStart||!event.changedTouches.length)return;
  const touch=event.changedTouches[0],dx=touch.clientX-swipeStart.x,dy=touch.clientY-swipeStart.y;
  swipeStart=null;
  if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.5)return;
  const current=thumbs.findIndex(button=>button.getAttribute('aria-pressed')==='true');
  const next=thumbs[(current+(dx<0?1:-1)+thumbs.length)%thumbs.length];
  next?.click();
},{passive:true,signal});
galleryMain.addEventListener('touchcancel',()=>{swipeStart=null;},{passive:true,signal});
thumbs.forEach(button=>button.addEventListener('click',()=>{
  const railRect=thumbRail.getBoundingClientRect(),rect=button.getBoundingClientRect();
  if(rect.left<railRect.left||rect.right>railRect.right){
    thumbRail.scrollTo({left:thumbRail.scrollLeft+rect.left-railRect.left-(railRect.width-rect.width)/2,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
},{signal}));
const dialog=root.querySelector('.dp-video-dialog'),video=dialog.querySelector('video'),title=dialog.querySelector('.dp-story-title');
let lastTrigger;cleanup.push(()=>{video.pause();if(dialog.open)dialog.close();});
root.querySelectorAll('.dp-story').forEach(button=>button.addEventListener('click',()=>{lastTrigger=button;title.textContent=button.dataset.storyTitle;dialog.setAttribute('aria-label',button.dataset.storyTitle);video.src=button.dataset.storySrc;video.poster=button.dataset.storyPoster;dialog.showModal();video.play().catch(()=>{});}));
dialog.querySelector('.dp-close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.load();if(lastTrigger)lastTrigger.focus();});
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
});}
initDodo();document.addEventListener('shopify:section:load',initDodo);document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-dodo-section="product"]').forEach(root=>root.dodoCleanup?.());});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
